import { SpinnerModalComponent } from './../spinner/spinner-modal.component';
import { SiteModel } from 'src/app/shared/models/societe-linked/site.model';
import { Ca2Model } from 'src/app/shared/models/societe-linked/ca2.model';
import { GestionReferentielComponentService } from './../../../../core/gestion-referentiel/gestion-referentiel-component.service';
import { SeuilService } from './../../../services/simple/seuil.service';
import { SeuilModel } from './../../../models/simple-types/seuil.model';
import { Form, UntypedFormGroup } from '@angular/forms';
import { SiteService } from './../../../services/societe-linked/site.service';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { GestionCa2Component } from './../../../../core/gestion-referentiel/gestion-ca2/gestion-ca2.component';
import { ToastrService } from 'ngx-toastr';
import { Ca2Service } from './../../../services/societe-linked/ca2.service';
import { Router } from '@angular/router';
import { Component, OnInit, Inject, OnChanges } from '@angular/core';
import { Ca1Model } from 'src/app/shared/models/societe-linked/ca1.model';
import { Ca1Service } from 'src/app/shared/services/societe-linked/ca1.service';

export interface DialogData {
  form: UntypedFormGroup;
  ca2s: Ca2Model[];
  ca1s: Ca1Model[];
  societeId: number;
  result: boolean;
}
@Component({
  selector: 'app-modal-add-ca2',
  templateUrl: './modal-add-ca2.component.html',
  styleUrls: ['./modal-add-ca2.component.scss']
})
export class ModalAddCa2Component implements OnInit {
  ca1: Ca1Model;
  ca2s: Ca2Model[];
  form: UntypedFormGroup;
  constructor(public dialog: MatDialog
            , public dialogRef: MatDialogRef<GestionCa2Component>
            , @Inject(MAT_DIALOG_DATA) public data: DialogData
            , private toastr: ToastrService
            , private router: Router
            , private ca1Service: Ca1Service
            , private ca2Service: Ca2Service) {

             }

  ngOnInit(): void {
    this.ca2s = this.data.ca2s;
    this.form = this.data.form;
    if (this.form) {
      this.ca1 = this.data.ca1s.find(s => s.code === this.form.get('codeCa1').value);
    }
  }


  onModalCancel(): void {
    this.data.result = false;
    this.dialogRef.close(false);
  }

  onModalConfirm(): void {
    if (this.form.valid) {
      const ca2 = this.form.getRawValue();
      this.ca1 ? ca2.codeCa1 = this.ca1.code : ca2.codeCa1 = null;
      ca2.idSociete = this.data.societeId;
      // Création
      if (!this.form.get('id').value){
        const dialogRef = this.dialog.open(SpinnerModalComponent);
          this.ca2Service.save(ca2).subscribe((a: Ca2Model) => {
            this.toastr.success('', 'Création du ca2 ' + a.code + ' réussie');
            this.dialogRef.close(true);
            dialogRef.close();
          }, (error) => {
            this.dialogRef.close(true);
            dialogRef.close();
          });
      }else { // Modification
        const dialogRef = this.dialog.open(SpinnerModalComponent);
        this.ca2Service.update(ca2.id, ca2).subscribe((a: Ca2Model) => {
          this.toastr.success('', 'Modification du ca2 ' + a.code + ' réussie');
          this.dialogRef.close(true);
          dialogRef.close();
        }, (error) => {
          this.dialogRef.close(true);
          dialogRef.close();
        });
      }
    } else {
      this.displayErrors();
    }
  }

  displayErrors(): void {
    for (const index in this.form.controls) {
      if (index) {
        this.form.controls[index].markAsTouched();
      }
    }
  }
}

